import { object, string, number } from 'yup';


export const formularyMedical = object({
    firstName: string().required('El primer nombre es obligatorio'),
    lastName: string().required('El Primer apellido es obligatorio'),
    profileId: number().required('Seleccione un perfil por favor'),
    exequatur: string().required('El Exequatur es obligatorio'),
    email: string().email('El correo electrónico no es válido').required('El correo electrónico es obligatorio'),
    municipalityId: number().required('Seleccionar Municipio').moreThan(0, 'Seleccionar Municipio'),
    provinceId: number().required('Seleccionar Provincia').moreThan(0, 'Seleccionar Provincia'),
})

export const formularyUser = object({
    firstName: string().required('El primer nombre es obligatorio'),
    lastName: string().required('El Primer apellido es obligatorio'),
    profileId: number().required('Seleccione un perfil por favor'),
    email: string().email('El correo electrónico no es válido').required('El correo electrónico es obligatorio'),
})

export const formularyBranch = object({
    name: string().required('Nombre de Sucursal es Obligatorio'),
    contact: string().required('Campo de Contacto es obligatorio'),
    municipalityId: number().required('Seleccionar Municipio').moreThan(0, 'Seleccionar Municipio'),
    provinceId: number().required('Seleccionar Provincia').moreThan(0, 'Seleccionar Provincia'),
    email: string().email('El correo electrónico no es válido').required('El correo electrónico es obligatorio'),
})

export const formularyProvider = object({
    name: string().required('asignar nombre De Consultorio'),
    contactName: string().required('asignar Contacto'),
    commercialName: string().required('asigne un Nombre Comercial'),
    contactEmail: string().email(' verifique!! Correo Electrónico no es válido').required('asigne un Correo Electronico'),
    municipalityId: number().required('Seleccionar Municipio').moreThan(0, 'Seleccionar Municipio'),
    channelId: number().required('seleccione un Canal'),
    provinceId: number().required('Seleccionar Provincia').moreThan(0, 'Seleccionar Provincia'),
})

